import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet, MenuController, Platform} from '@ionic/angular/standalone';
import { ConfigProvider } from './core/providers/config';
import { APIService } from './core/providers/apiservices';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private menuCtrl: MenuController,
    private configProvider: ConfigProvider
  ) {
    this.initializeApp();
    

  }
  initializeApp() {
    this.platform.ready().then(async () => {
      this.menuCtrl.enable(false);
      await this.getConfig();
    });
  }

  async getConfig(){
    var me=this;

    this.configProvider.getConfig().then(
      async response => {
        var temp:any=[];
        temp.push(response);

        if (APIService.gAppInsights){
        }
        else{
          APIService.gAppInsights = new ApplicationInsights({ config: {
            instrumentationKey: temp[0].INSIGHTS
            /* ...Other Configuration Options... */
          } });
          APIService.gAppInsights.loadAppInsights();
        }

        APIService.API_URL=temp[0].API_URL;
        APIService.API_KEY=temp[0].API_KEY;

        APIService.storage_key=temp[0].STORAGE_KEY;

        APIService.environment=temp[0].ENVIRONMENT;
        APIService.APPID = temp[0].APPID;
        APIService.TENANT = temp[0].TENANT;
        APIService.PACKAGE_NAME = temp[0].PACKAGE_NAME;
        APIService.HASH_ANDROID = temp[0].HASH_ANDROID;

      }
    );
  }
}
